var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filterWrapper moreFilters" }, [
    _c(
      "button",
      { staticClass: "no-button title", on: { click: _vm.toggle } },
      [
        _c("span", { staticClass: "text-wrapper" }, [
          _c("span", { staticClass: "text-label" }, [
            _vm._v("\n        " + _vm._s(_vm.text) + "\n      "),
          ]),
          _c("i", {
            staticClass:
              "hidden-desktop dsio-sliders-h-light more-filters-icon",
          }),
          _vm.nbContextFilters
            ? _c("span", { staticClass: "nbChecked" }, [
                _c("span", { staticClass: "count" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.nbContextFilters) + "\n        "
                  ),
                ]),
              ])
            : _vm._e(),
          !_vm.isMobileScreen
            ? _c("i", {
                class: [
                  _vm.isOpen
                    ? "dsio-angle-up icon-arrow"
                    : "dsio-angle-down icon-arrow",
                ],
              })
            : _vm._e(),
          _vm.isOpen && _vm.isMobileScreen
            ? _c("span", {
                staticClass: "nb-results",
                domProps: { innerHTML: _vm._s(_vm.counter) },
              })
            : _vm._e(),
        ]),
        _vm.isOpen && _vm.isMobileScreen
          ? _c("i", { staticClass: "dsio-close close" })
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }